import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
const LoginPopup = ({ setShow }: any) => {
	const { t } = useTranslation();
	return (
		<div className="fixed p-5 top-0 left-0 h-screen w-full bg-black bg-opacity-50 flex items-center justify-center z-50">
			<div className="bg-white p-6 rounded-xl shadow-lg w-full max-w-sm text-center space-y-4">
				<h2 className="text-xl font-semibold text-gray-800">{t("login-required")}</h2>
				<p className="text-gray-600">{t("please-login-first")}</p>
				<div className="flex justify-center gap-4 pt-4">
					<button
						onClick={() => setShow(false)}
						className="bg-gray-300 hover:bg-gray-400 px-4 py-2 rounded"
					>
						{t("cancel")}
					</button>
					<Link
						to="/auth/login"
						className="bg-primary text-white hover:bg-primary-dark px-4 py-2 rounded"
					>
						{t("loginOrSignup")}
					</Link>
				</div>
			</div>
		</div>
	)
}


export default LoginPopup